import styled from "styled-components";

import { WorkspaceControllerState } from "js/controllers/WorkspaceController";
import { t } from "js/i18n";
import FetchingClickShield from "js/react/components/FetchingClickShield";
import { SearchBarSort } from "js/react/views/SharedResources/Components";
import UpgradeIcon from "js/Components/UpgradeIcon";

export const TemplateCreationClickShield = styled(FetchingClickShield).attrs({
    backgroundColor: "rgb(248, 250, 252)",
})`
    &&& {
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 2001;
    }
`;

export const TAG_FILTER_ALL = "__all__";
export const SEARCH_FIELD_ALL = "__all__";

export const contentFilterOptions = [
    { field: SEARCH_FIELD_ALL, label: t("All Content") },
    { field: "slide:text", label: t("Slide Text") },
    { field: "resource:metadata:name", label: t("Name") },
    { field: "resource:metadata:description", label: t("Description") },
    { field: "resource:tagsText", label: t("Tags") },
];

export const sortOptions: SearchBarSort[] = [{
    field: "resource.metadata.name", label: t("Name"), direction: "asc", icon: "sort_by_alpha",
}, {
    field: "resource.metadata.ratedByUsersCount", label: t("Rating"), direction: "desc", icon: "star",
}, {
    field: "resource.createdAt", label: t("Recently Created"), direction: "desc", icon: "calendar_month",
}, {
    field: "document.modifiedAt", label: t("Recently Modified"), direction: "desc", icon: "edit_calendar",
}];

export const TemplatesListHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const TemplatesListHeaderActions = styled.div`
    display: flex;
`;

export const TemplatesContent = styled.div`
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;

export const UpgradeIconWrapper = styled(UpgradeIcon)`
    cursor: pointer;
    width: 18px;
    height: 18px;
    margin-right: 10px;
`;

export type LibraryTemplateCreateOptions =
    | { type: "starter-template"; templateId: string }
    | { type: "team-template"; templateId: string };

export type LibraryTemplatesPaneProps = WorkspaceControllerState & {
    pane: string;
    sideBarWidth?: number;
    onResizeSidebar?: (width: number) => void;
    showNavigationSidebar?: boolean;
};

export type LibraryTemplatesLayoutProps = LibraryTemplatesPaneProps & {
    onCreate: (options: LibraryTemplateCreateOptions) => void | Promise<void>;
    isCreatingPresentation: boolean;
};
